import { Box, MenuItem, Stack, TextField, Typography } from "@mui/material";
import LookupChip from "../LookupChip";

export default function ChipListPicker({
  label,
  addLabel,
  values,
  options,
  onAdd,
  onRemove,
}) {
  const styles = {
    root: { mb: 2 },
    chips: { flexWrap: "wrap", gap: 0.75, mb: 1 },
    chip: { maxWidth: 180 },
    select: { minWidth: 220 },
    selectMenu: {
      slotProps: { paper: { style: { maxHeight: 320, maxWidth: 360 } } },
    },
    menuItem: {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };

  return (
    <Box sx={styles.root}>
      <Typography variant="overline" color="text.secondary" display="block">
        {label}
      </Typography>
      <Stack direction="row" sx={styles.chips}>
        {values.map((value) => (
          <LookupChip
            key={value}
            label={value}
            variant="plain"
            onDelete={() => onRemove(value)}
            sx={styles.chip}
          />
        ))}
      </Stack>
      <TextField
        select
        size="small"
        label={`Add ${addLabel}`}
        value=""
        onChange={(e) => onAdd(e.target.value)}
        sx={styles.select}
        slotProps={{ select: { MenuProps: styles.selectMenu } }}
      >
        {options
          .filter((option) => !values.includes(option))
          .map((option) => (
            <MenuItem key={option} value={option} sx={styles.menuItem}>
              {option}
            </MenuItem>
          ))}
      </TextField>
    </Box>
  );
}
